/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_TypeInputs */

const th_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภทกิจกรรม`)
};

const en_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event type`)
};

const ja_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの種類`)
};

const zh_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛事类型`)
};

const es_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de evento`)
};

const pt_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de evento`)
};

const id_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis acara`)
};

const fr_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d’événement`)
};

const tl_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri ng event`)
};

const vi_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại sự kiện`)
};

const ko_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 유형`)
};

const de_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-Typ`)
};

const ru_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип события`)
};

const tr_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik türü`)
};

const it_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di evento`)
};

const pl_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ wydarzenia`)
};

const uk_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип події`)
};

const hi_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन का प्रकार`)
};

const ar_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الفعالية`)
};

const ms_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis acara`)
};

const bn_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজনের ধরন`)
};

const zh_tw2_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事類型`)
};

const zh_hk2_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽事類型`)
};

const ur_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ کی قسم`)
};

const fa_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`گونهٔ رویداد`)
};

const sw_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aina ya tukio`)
};

const nl_event_type = /** @type {(inputs: Event_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soort evenement`)
};

/**
* | output |
* | --- |
* | "Event type" |
*
* @param {Event_TypeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const event_type = /** @type {((inputs?: Event_TypeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_TypeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_event_type(inputs)
	if (locale === "ja") return ja_event_type(inputs)
	if (locale === "zh") return zh_event_type(inputs)
	if (locale === "es") return es_event_type(inputs)
	if (locale === "pt") return pt_event_type(inputs)
	if (locale === "id") return id_event_type(inputs)
	if (locale === "fr") return fr_event_type(inputs)
	if (locale === "tl") return tl_event_type(inputs)
	if (locale === "vi") return vi_event_type(inputs)
	if (locale === "ko") return ko_event_type(inputs)
	if (locale === "de") return de_event_type(inputs)
	if (locale === "ru") return ru_event_type(inputs)
	if (locale === "tr") return tr_event_type(inputs)
	if (locale === "it") return it_event_type(inputs)
	if (locale === "pl") return pl_event_type(inputs)
	if (locale === "uk") return uk_event_type(inputs)
	if (locale === "hi") return hi_event_type(inputs)
	if (locale === "ar") return ar_event_type(inputs)
	if (locale === "ms") return ms_event_type(inputs)
	if (locale === "bn") return bn_event_type(inputs)
	if (locale === "zh-TW") return zh_tw2_event_type(inputs)
	if (locale === "zh-HK") return zh_hk2_event_type(inputs)
	if (locale === "ur") return ur_event_type(inputs)
	if (locale === "fa") return fa_event_type(inputs)
	if (locale === "sw") return sw_event_type(inputs)
	if (locale === "nl") return nl_event_type(inputs)
	return en_event_type(inputs)
});